//
import { color } from "./variables"
import { injectGlobal } from "react-emotion/macro"

injectGlobal`
  .react-add-to-calendar__button,
  .btn,
  .neoncrm-button,
  .neoncrm-submit,
  .neon_C_content input[type="button"] {
    padding: 13px 15px;
    border-radius: 2px;
    line-height: 1;
    text-transform: uppercase;
    text-decoration: none;
    font-weight: 400;
    font-size: 14px;
    white-space: nowrap;
    display: inline-block;
    cursor: pointer;
    transition: color 0.5s ease, background 0.5s ease, border 0.5s ease, opacity 0.5s ease;
    border: none;

    &:hover, &:focus { text-decoration: none; }

    &:disabled { opacity: 0.35; cursor: default; }
  }
  
  .btn-purple,
  .neoncrm-button,
  .neoncrm-submit,
  .neon_C_content input[type="button"] {
    background-color: ${color.rgb.purple[1]};
    &:hover, &:focus { background-color: ${color.rgba.purple(0.75)[1]}; }
    &:focus { outline: 1px solid ${color.rgb.purple[1]}; }
    color: ${color.rgb.white[0]};
  }

  .btn-orange,
   .react-add-to-calendar__button {
    background-color: ${color.rgb.orange[0]};
    &:hover, &:focus { background-color: ${color.rgba.orange(0.75)[0]}; }
    &:focus { outline: 1px solid ${color.rgb.orange[0]}; }
    color: ${color.rgb.white[0]};
  }

  .btn-clear {
    color: ${color.rgb.white[0]};
    border: 1px solid ${color.rgb.white[0]};
    &:hover, &:focus {
      background-color: ${color.rgba.white(0.2)[0]};
    }
  }
`



// WEBPACK FOOTER //
// /opt/build/repo/src/styles/button.js